import { render, staticRenderFns } from "./unsubscribe.vue?vue&type=template&id=3ca119d0&scoped=true&"
import script from "./unsubscribe.vue?vue&type=script&lang=js&"
export * from "./unsubscribe.vue?vue&type=script&lang=js&"
import style0 from "./unsubscribe.vue?vue&type=style&index=0&id=3ca119d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca119d0",
  null
  
)

export default component.exports